import axios from "axios";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";

const OutletContext = createContext();

export const OutletProvider = ({ children }) => {
  const [outletOptions, setOutletOptions] = useState([]);
  const [fullOutlets, setFullOutlets] = useState([]);
  const [defaultOutlet, setDefaultOutlet] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [userID, setUserID] = useState(() => localStorage.getItem("userID"));

  useEffect(() => {
    const syncAuth = () => {
      setToken(localStorage.getItem("token"));
      setUserID(localStorage.getItem("userID"));
    };

    window.addEventListener("authChanged", syncAuth);
    return () => window.removeEventListener("authChanged", syncAuth);
  }, []);

  const fetchOutlets = useCallback(async () => {
    setLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/outlets`,
        {
          token,
          employee_id: Number(userID),
        }
      );

      const outletList = response.data || [];
      const outlets = outletList.map((outlet) => outlet.name);

      setOutletOptions(outlets);
      setFullOutlets(outletList);

      const outletData = outlets[0] || null;
      setDefaultOutlet(outletData);
      setError(null);
    } catch (err) {
      setError("Failed to fetch outlets. Please try again.");

      console.error("Error fetching outlets:", err);

      toast.error(
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Failed to fetch outlets. Please try again."
      );
    } finally {
      setLoading(false);
    }
  }, [token, userID]);

  useEffect(() => {
    if (!token || !userID) return;

    fetchOutlets();
  }, [token, userID, fetchOutlets]);

  return (
    <OutletContext.Provider
      value={{
        outletOptions,
        fullOutlets,
        defaultOutlet,
        setDefaultOutlet,
        fetchOutlets,
        error,
        loading,
      }}
    >
      {children}
    </OutletContext.Provider>
  );
};

export const useOutlet = () => useContext(OutletContext);